<template>
  <div class="pack_menu_list">
    <div class="white_btn_area">
      <!-- <div class="pack_menu" :class="{ active: showCardType == -1 }" @click="selectPackType(-1)">Twitter</div> -->
      <!-- <div class="pack_menu" :class="{ active: showCardType == -2 }" @click="selectPackType(-2)">How to play</div>
      <div class="pack_menu" :class="{ active: showCardType == -1 }" @click="selectPackType(-2)>
        Everyone's Record
      </div> -->
      <button class="pack_menu white_btn" :class="{ active: showCardType == -2 }" @click="selectPackType(-2)">How to play</button>
      <button class="pack_menu white_btn" :class="{ active: showCardType == -1 }" @click="selectPackType(-1)">Everyone's Record</button>
    </div>
    <div class="gradation_area">
      <!-- <div class="pack_menu" :class="{ active: showCardType == 2 }" @click="selectPackType(2)">Pokémon</div> -->
      <button class="pack_menu gradation" :class="{ active: showCardType == 2 }" @click="selectPackType(2)">Pokémon</button>
      <!-- <div class="pack_menu" :class="{ active: showCardType == 3 }" @click="selectPackType(3)">Weiß<br>Schwarz</div> -->
      <!-- <div class="pack_menu" :class="{active: showCardType == 4}" @click="selectPackType(4)">SHADOW<br>VERSE</div> -->
      <!-- <div class="pack_menu" :class="{active: showCardType == 6}" @click="selectPackType(6)">Duel<br>Masters</div> -->
      <!-- <div class="pack_menu" :class="{ active: showCardType == 5 }" @click="selectPackType(5)">ONE PIECE</div> -->
      <button class="pack_menu gradation" :class="{ active: showCardType == 5 }" @click="selectPackType(5)">ONE PIECE</button>
      <!-- <div class="pack_menu" :class="{ active: showCardType == 11 }" @click="selectPackType(11)">DragonBall</div> -->
      <!-- <div class="pack_menu" :class="{ active: showCardType == 999996 }" @click="selectPackType(999996)">Others</div> -->
      <button class="pack_menu gradation" :class="{ active: showCardType == 1 }" @click="selectPackType(1)">Yu-Gi-Oh!</button>
      <button class="pack_menu gradation" :class="{ active: showCardType == 999996 }" @click="selectPackType(999996)">TCG MIX</button>
      <button class="pack_menu gradation" :class="{ active: showCardType == 9999 }" @click="selectPackType(9999)">Hobby</button>
      <!-- <button class="pack_menu gradation" :class="{ active: showCardType == 999995 }" @click="selectPackType(999995)">others</button> -->
      <!-- <div class="pack_menu" :class="{active: showCardType == 9}" @click="selectPackType(9)">MTG</div> -->
      <!-- <div class="pack_menu" :class="{active: showCardType == 7}" @click="selectPackType(7)">figures</div> -->
      <!-- <div class="pack_menu" :class="{active: showCardType == 8}" @click="selectPackType(8)">Video<br>games</div> -->

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      showCardType: 'pack/topCardType',
    }),
  },
  methods: {
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
  },
};
</script>

<style lang="scss" scoped>
// .pack_menu_list {
//   position: relative;
//   left: 50%;
//   transform: translateX(-50%);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background-color: #fafafa;
//   height: 70px;
//   margin: 20px 0;
//   width: 100vw;
//   overflow-x: auto;
//   @media screen and  (max-width: $tabletWidth) {
//     flex-wrap: wrap;
//     height: 100px;
//   }

//   .pack_menu {
//     color: $mainColor;
//     width: 126px;
//     min-width: 126px;
//     height: 100%;
//     display: flex;
//     text-align: center;
//     justify-content: center;
//     align-items: center;
//     cursor: pointer;
//     transition: .4s;
//     position: relative;
//     margin: 0 1px;
//     box-shadow: -1px 0px 1px 1px rgba(200, 200, 200, 0.5), 0px -1px 0px 1px rgba(200, 200, 200, 0.5);

//     &:hover {
//       background-color: #DDE6FF;
//     }

//     &.active {
//       background-color: #DDE6FF;
//     }
//     @media screen and  (max-width: $tabletWidth) {
//       height: 50px;
//     }
//   }
// }
.pack_menu_list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.pack_menu {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.8);
  margin: 10px;
}
.pack_menu.active {
  position: relative;
  display: inline-block;
  font-weight: bold;
  border: none;
  background: transparent;
  z-index: 1;
  background-clip: text;
}
.pack_menu.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3px;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0); /* 枠線内側を透過 */
  -webkit-mask-composite: xor; /* 内側を切り抜き */
  z-index: -1;
  border-radius: 30px;
}

.white_btn {
  background: $white;
}
.white_btn.active {
  color: #fff;
  text-shadow: 2px 3px 6px rgba(0, 0, 0, 0.5);
}
.white_btn.active::before {
  background: linear-gradient(90deg, #fff, #fff);
}

.gradation {
  background: linear-gradient(90deg, #40afff, #f23fbf);
  color: white;
  text-shadow: 2px 3px 6px rgba(0, 0, 0, 0.5);
}
.gradation.active {
  // color: transparent;
  background-image: linear-gradient(90deg, #40afff, #f23fbf);
}
.gradation.active::before {
  background: linear-gradient(90deg, #40afff, #f23fbf);
}

@media screen and (max-width: $tabletWidth) {
  .pack_menu_list {
    flex-direction: column;
    margin-bottom: 10px;
  }
  .white_btn_area {
    width: 100%;
    display: flex;
    justify-content: center;
    .white_btn {
      width: 45%;
    }
  }
  .gradation_area {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .gradation {
      width: 30%;
      min-width: 100px;
    }
  }
  .pack_menu {
    font-size: 12px;
    margin: 5px;
    padding: 12px 10px;
  }
}
</style>
